// extracted by mini-css-extract-plugin
module.exports = {"root":"TextBox_root__2S6KL","inputWrapper":"TextBox_inputWrapper__AOiC8","full":"TextBox_full__31zQ2","visuallyHidden":"TextBox_visuallyHidden__37WMM"};